"use strict";
/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * eloomi-skills-persona (1.0)
 * - This service is using new eloomi project structure. You should be able to make HTTP calls from this UI.
 *
 * The version of the OpenAPI document: 1.0

 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=user-business-title-response.js.map